import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FirLocalAcctDescService {

  constructor(private http: HttpClient) { }

  /**
   * Save FIR Local Account Description
   * Matches original AngularJS service: FirLocalAcctDescGroupObjFactory.saveFirLocalAcctDesc
   * Endpoint: /saveJsonObject?action_code=f9a3p3
   * Process: FOREIGN_LOCAL_ACCT_DESC_SAVE
   */
  saveFirLocalAcctDesc(
    baseUrl: string,
    returnObj: any,
    details: any[],
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=f9a3p3`;

    // Build params matching original AngularJS structure
    const jsonObj = JSON.stringify(details);
    const jsonSettings = JSON.stringify(returnObj);

    let params: any = { ...filterParams };
    
    // Merge with global params
    if (globalService?.globalParams) {
      params = { ...globalService.globalParams, ...params };
    }

    // Add JSON data
    params.jsonObj = jsonObj;
    params.jsonSettings = jsonSettings;
    params.process_name = 'FOREIGN_LOCAL_ACCT_DESC_SAVE';

    // Build URL encoded form data (application/x-www-form-urlencoded)
    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    // CRITICAL: Always include withCredentials: true
    return this.http.post<any>(url, urlEncoded.toString(), { 
      headers, 
      withCredentials: true 
    }).pipe(
      map(response => response),
      catchError(error => {
        console.error('Error saving FIR Local Acct Desc:', error);
        throw error;
      })
    );
  }
}


